module.exports = __webpack_public_path__ + "img/aside.3c5c9bd9.webp";